'use strict';

var HTTP_STATUS_SUCCESS_CODES = {
    HTTP_STATUS_OK: 200,
    HTTP_STATUS_CREATED: 201,
    HTTP_STATUS_ACCEPTED: 202,
    HTTP_STATUS_NON_AUTHORITATIVE_INFORMATION: 203,
    HTTP_STATUS_NO_CONTENT: 204,
    HTTP_STATUS_RESET_CONTENT: 205,
    HTTP_STATUS_PARTIAL_CONTENT: 206,
    HTTP_STATUS_MULTI_STATUS: 207,
    HTTP_STATUS_ALREADY_REPORTED: 208,
    HTTP_STATUS_IM_USED: 226,
};
var HTTP_STATUS_FAILURE_CODES = {
    HTTP_STATUS_NOT_ACCEPTABLE: 406,
};

exports.HTTP_STATUS_FAILURE_CODES = HTTP_STATUS_FAILURE_CODES;
exports.HTTP_STATUS_SUCCESS_CODES = HTTP_STATUS_SUCCESS_CODES;
//# sourceMappingURL=apis.js.map
